import { Component, Input } from '@angular/core';
import { IonColor } from '../../types/ion-color.type';

@Component({
    selector: 'shared-status-tag',
    templateUrl: './status-tag.component.html',
    styleUrl: './status-tag.component.scss',
    standalone: false
})
export class StatusTagComponent {
  @Input() color: IonColor = 'primary';
  @Input() tag = '';
}
